import { useHits } from 'react-instantsearch-core';
import { FormattedPlural, useIntl } from 'react-intl';

import { commonMessages } from '@/messages/common';
import type { ListingType } from '@/states/listingState';

import type { ListingFiltersVariant } from '../../types';

import * as S from './HitsSummary.styles';

interface HitsSummaryProps {
  filteredResultsReady?: boolean;
  initialResults?: any;
  listingType: '' | ListingType;
  variant?: ListingFiltersVariant;
}

export const HitsSummary = ({
  filteredResultsReady = true,
  initialResults,
  listingType,
  variant = 'default',
}: HitsSummaryProps) => {
  let { results } = useHits();
  const { formatMessage } = useIntl();

  if (!filteredResultsReady) {
    return null;
  }

  if (results?.nbHits === 0) {
    results = {
      ...results,
      ...initialResults,
    };
  }
  return (
    <S.Wrapper data-test-id='HitsSummaryWrapper' variant={variant}>
      {results?.nbHits}{' '}
      {listingType == 'WATCH' && (
        <FormattedPlural
          data-test-id='HitsSummaryFormattedPluralWatch'
          one={formatMessage(commonMessages.watch)}
          other={formatMessage(commonMessages.watches)}
          value={results?.nbHits ?? 0}
        />
      )}
      {listingType == 'STRAP' && (
        <FormattedPlural
          data-test-id='HitsSummaryFormattedPluralStrap'
          one={formatMessage(commonMessages.strap)}
          other={formatMessage(commonMessages.straps)}
          value={results?.nbHits ?? 0}
        />
      )}
      {listingType == 'STORE' && (
        <FormattedPlural
          data-test-id='HitsSummaryFormattedPluralStore'
          one={formatMessage(commonMessages.store)}
          other={formatMessage(commonMessages.stores)}
          value={results?.nbHits ?? 0}
        />
      )}
      {listingType == 'EYEWEAR' && (
        <FormattedPlural
          data-test-id='HitsSummaryFormattedPluralEyewear'
          one={formatMessage(commonMessages.sunglasses)}
          other={formatMessage(commonMessages.sunglasses)}
          value={results?.nbHits ?? 0}
        />
      )}
    </S.Wrapper>
  );
};

HitsSummary.displayName = 'HitsSummary';
